<template>
<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-color-tugraph`]" width="1em" height="1em" v-bind="$attrs"><path d="M14.4709 18.906C14.4709 18.906 11.8943 18.7792 12.3167 16.1182C12.7391 13.4571 13.8373 8.8953 13.8373 8.8953H16.6251L15.1045 15.3579C15.1045 15.3579 14.8933 16.4983 15.8648 16.4983H19.4129L21.1869 8.8953H23.9747L21.5671 18.906H14.4709ZM11.0496 7.62811C8.95872 7.62811 8.89535 9.27543 8.89535 9.27543L6.61445 18.7792H3.95341C3.95341 18.7792 5.85418 10.6059 6.48774 8.00824C7.12132 5.41057 9.78239 5.09375 9.78239 5.09375L14.4709 5.22046L13.8373 7.62808L11.0496 7.62811ZM1.03889 5.22049H7.12129L0.0251465 9.27543L1.03889 5.22049Z" :fill="useCurrentColor ? 'currentColor' : '#4276BB'"/></svg>
</template>
<script>

export default {
  name: 'IconColorTugraph',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
